import {Samples} from 'src/app/infrastructure/moovement-api/models/samples';

const bytesPerLocation = 36;
const dateTimeRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/;

export function toSampleValues(payload: number[]): {samples: Samples.SampleValue<Samples.NfcGpsFix>[], discrepancyMessage: string | null } {
  const numberOfLocations = payload[3] * 256 + payload[2];
  const result: Samples.SampleValue<Samples.NfcGpsFix>[] = [];
  let discrepancyMessage: string | null = null;

  for (let i = 0; i < numberOfLocations; i++) {
    const offset = 4 + i * bytesPerLocation;

    const slice = payload.slice(offset, offset + bytesPerLocation);
    const intArray = new Uint8Array(slice);
    const view = new DataView(intArray.buffer);

    const latitude = view.getFloat64(0, true);
    const longitude = view.getFloat64(8, true);
    const hdop = view.getFloat32(20, true);
    const year = view.getUint16(24, true);
    const month = view.getUint8(26);
    const day = view.getUint8(27);
    const hour = view.getUint8(28);
    const minute = view.getUint8(29);
    const second = view.getUint8(30);
    const fixQuality = view.getUint8(31);
    const timeToFirstFix = view.getUint16(32, true);
    const messageCounter = view.getUint16(34, true);
    const instant = `${year}-${toTimestampSegment(month)}-${toTimestampSegment(day)}T${toTimestampSegment(hour)}:${toTimestampSegment(minute)}:${toTimestampSegment(second)}Z`

    if (dateTimeRegex.test(instant) && !isNaN(Date.parse(instant))) {
      result.push({
        instant: instant,
        value: {
          position: {
            coords: [latitude, longitude],
            srid: 4326
          },
          hdop: hdop,
          fixQuality: fixQuality,
          timeToFirstFix: timeToFirstFix,
          messageCounter: messageCounter
        }
      });
    } else {
      discrepancyMessage = 'Filtered messages due to invalid instant values'
    }

  }
  return {
    samples: result,
    discrepancyMessage: discrepancyMessage
  };
}

function toTimestampSegment(value: number): string {
  return value.toString().padStart(2, '0');
}
